import { api } from "../axios";

const MARK_FAVORITE_URL = import.meta.env.VITE_MARK_FAVORITE_URL;
const GET_ALL_MY_FAVORITE_PROPERTIESP_URL = import.meta.env
  .VITE_GET_ALL_MY_FAVORITE_PROPERTIES;

export const toggleMarkFavoriteProperty = async (propertyId: number) => {
  try {
    const res = await api.post(MARK_FAVORITE_URL, {
      property_id: propertyId,
    });
    return res.data;
  } catch (error) {
    console.log("favorites api markFavorite: ", error);
    throw error;
  }
};

export const getAllMyFavorites = async () => {
  try {
    const res = await api.get(GET_ALL_MY_FAVORITE_PROPERTIESP_URL);
    return res.data;
  } catch (error) {
    console.log("favorites api deletePropertyFromFavorites: ", error);
    throw error;
  }
};
